<template>
    <div class="tab_bar">
        <div v-for="item in tabBar"
            :key="item.id"
            @click="changeTabBarFuc(item.id, item.url)"
            class="tab_bar_item">
            <img :src="$route.name === item.url ? item.activeIcon : item.icon"
                class="icon" alt=""/>
            <span :class="['label', $route.name === item.url && 'active']">
                {{ item.label }}
      </span>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            tabBar: [
                {
                    id: 1,
                    icon: require('@/icon/my/my-auth-not.png'),
                    activeIcon: require('@/icon/my/my-auth-yes.png'),
                    label: '测评分类',
                    url: 'Evaluation_list',
                },
                // {
                //     id: 2,
                //     icon: require('@/icon/my/my-unac.png'),
                //     activeIcon: require('@/icon/my/my-ac.png'),
                //     label: '我的测评',
                //     url: 'my_evaluation',
                // },
                {
                    id: 3,
                    icon: require('@/icon/my/my-unac.png'),
                    activeIcon: require('@/icon/my/my-ac.png'),
                    label: '报告中心',
                    url: 'report_center',
                },
                //  {
                //     id: 5,
                //     icon: require('@/icon/my/report.png'),
                //     activeIcon: require('@/icon/my/report_h.png'),
                //     label: '我的报告',
                //     url: 'My_report',
                // },
                // {
                //     id: 4,
                //     icon: require('@/icon/my/my-unac.png'),
                //     activeIcon: require('@/icon/my/my-ac.png'),
                //     label: '个人中心',
                //     url: 'my_center',
                // },
            ],
            nowID: 1,
        }
    },
    mounted () {
        // this.$route.name
        // if (sessionStorage.getItem('tabIndex')) {
        //     this.nowID = parseInt(sessionStorage.getItem('tabIndex'))
        // }
    },
    methods: {
        changeTabBarFuc (id, url) {
            if (sessionStorage.getItem('tabIndex') !== id) {
                sessionStorage.setItem('tabIndex', id)
                this.nowID = id
                this.$router.replace({ name: url })
            }
        },
    },
}
</script>
